const { proUrl, devUrl, proOssUrl, devOssUrl, proWs, devWs, proClient, devClient, downloadUrl, loginTheme } = window.baseURL;

const NODE_ENV = process.env.NODE_ENV === 'production'
let baseURL = NODE_ENV ? proUrl : devUrl;
const ossUrl = NODE_ENV ? proOssUrl : devOssUrl;
const wsUrl = NODE_ENV ? proWs : devWs;
const clientUrl = NODE_ENV ? proClient : devClient;

/** 开发环境连接本地服务器 */
if (process.env.NODE_ENV === 'development') {
    let is = window.sessionStorage.getItem("baseURL");
    is === null && window.sessionStorage.setItem(
        "baseURL",
        confirm("是否连接本地") ?
            `http://localhost:${prompt("本地服务端口号")}` :
            ""
    )
    is = window.sessionStorage.getItem("baseURL");
    baseURL = is ? is : devUrl;
}

export default {
    baseURL,
    ossUrl,
    wsUrl,
    clientUrl,
    downloadUrl,
    loginTheme
}